import { useEvent } from '../plugins/vue-gtag';
import Shepherd from 'shepherd.js';
import i18n from '../plugins/vue-i18n';

const gaTourCompleted = useEvent('tour_completed');
const gaTourCancelled = useEvent('tour_cancelled');
const gaTourBegun = useEvent('tour_begun');

const tour = new Shepherd.Tour({
  useModalOverlay: false
});
let tourTriggered = false;

function populateElements(steps){
  return steps.reduce((outputSteps, step)=>{
    const element = document.getElementsByClassName(step.class)[0];
    if (element){
      step.element = element;
      return outputSteps.concat(step);
    }
    return outputSteps;
  }, [])
}

export function isFirstTimeTour(){
  return !localStorage.getItem("first_time_tts_tour");
}

function saveTourInLocalStorage(status){
  localStorage.setItem("first_time_tts_tour", status);
}

export function completedTour(){
  saveTourInLocalStorage('completed');
  gaTourCompleted()
}

export function cancelledTour(){
  saveTourInLocalStorage('cancel');
  gaTourCancelled()
}

export function beginTour(steps = []){
  if (tourTriggered || !isFirstTimeTour()) return;
  tourTriggered = true;
  populateElements(steps).forEach((step)=>{
    tour.addStep({
      arrow: true,
      attachTo: {
        element: step.element,
        on: step.position
      },
      beforeShowPromise: step.beforeShowPromise,
      text: step.description,
      buttons: [{
        text: i18n.t('tour.controls.next'),
        action: step.nextAction && step.nextAction.bind(this, tour.next) || tour.next
      },{
        text: i18n.t('tour.controls.skip'),
        action: tour.cancel
      }]
    })
  })
  tour.on('complete', ()=>{
    completedTour();
  })
  tour.on('cancel', ()=>{
    cancelledTour();
  })
  gaTourBegun();
  tour.start();

  return true;
}
